var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.75 18.597v17.819c0 2.1179 1.7154 3.8333 3.8333 3.8333h11.416",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23 30.663c-1.4969 0-2.9939-0.4365-4.2914-1.3096l-11.259-7.5746c-2.2598-1.52-2.2598-4.8435-0.00192-6.3615l13.405-9.0179c1.2976-0.87208 2.9938-0.87208 4.2914 0l13.405 9.0179c1.254 0.8442 1.4501 2.0824 1.4501 2.5824",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.875
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.48 28.52-10.599 10.599",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.875
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m30.667 10.9h-15.333c-2.1179 0-3.8333 1.7154-3.8333 3.8333v9.7712",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.875
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m17.25 17.25h11.5",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.875
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2084 23H23",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.875
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.708,
    cy: 25.833,
    r: 3.8333,
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.875
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m28 39.25v-0.7782c0.0063-2.2139 1.7995-4.0071 4.0135-4.0135h5.3897c2.2139 0.0064 4.0072 1.7996 4.0135 4.0135v0.7782c0 0.5293-0.4291 0.9583-0.9584 0.9583h-11.5c-0.5292 0-0.9583-0.429-0.9583-0.9583z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.875
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailProfile);
export default __webpack_public_path__ + "static/media/email-profile.7ea47ce5.svg";
export { ForwardRef as ReactComponent };